import React from 'react';
import PropTypes from 'prop-types';
import { confirmable } from 'react-confirm';
import Snackbar from 'material-ui/Snackbar';

import HubTheme from '../../theme';

// Create spawnable dialogs.
// See https://www.npmjs.com/package/react-confirm for more

const NotificationSnackbar = ({ show, proceed, dismiss, cancel, message }) => {

  return (
    <HubTheme>
      <Snackbar
        open={show}
        message={message}
        onRequestClose={dismiss}
      />
      {/*
        autoHideDuration={this.state.autoHideDuration}
        action="undo"
        onActionTouchTap={this.handleActionTouchTap}
      */}
    </HubTheme>
  );
}

NotificationSnackbar.propTypes = {
  show: PropTypes.bool,            // from confirmable. indicates if the dialog is shown or not. 
  proceed: PropTypes.func,         // from confirmable. call to close the dialog with promise resolved. 
  cancel: PropTypes.func,          // from confirmable. call to close the dialog with promise rejected. 
  dismiss: PropTypes.func,         // from confirmable. call to only close the dialog. 
  message: PropTypes.string,       // arguments of your confirm function
}

// confirmable HOC pass props `show`, `dismiss`, `cancel` and `proceed` to your component. 
export default confirmable(NotificationSnackbar);



// WEBPACK FOOTER //
// ./src/components/NotificationSnackbar/index.jsx